import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ApiSecretModalComponent } from './api-secret-modal';

export const ApiSecretModalModule: string = ng
    .module('apiSecretModalModule', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('apiSecretModalComponent', ApiSecretModalComponent)
    .name;




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/api-secret-modal/api-secret-modal-module.ts